import React from 'react'
import { Button, makeStyles } from '@material-ui/core'
import {
	defaultB,
	defaultC,
	negativeB,
	negativeC,
	positiveB,
	positiveC,
	primaryB,
	primaryC,
	secondaryB,
	secondaryC,
	orangeB,
	orangeC
} from 'asterX-UIkit/constants/colors'
import PropTypes from 'prop-types'

const useStyles = makeStyles(theme => ({
	root: {
		paddingLeft: 16,
		paddingRight: 16,
		paddingTop: 12,
		paddingBottom: 12,
		height: 41,
		borderRadius: 9,
		fontWeight: 600,
		fontSize: 14,
		transition: 'none'
	},
	notActive: {
		backgroundColor: '#fff' + '!important',
		color: secondaryC,
		border: '1px solid #fff'
	},
	default: {
		backgroundColor: defaultB + '!important',
		color: defaultC,
		border: '1px solid #DCE6F3'
	},
	primary: {
		backgroundColor: primaryB + '!important',
		color: primaryC,
		border: '1px solid #fff'
	},
	secondary: {
		backgroundColor: secondaryB + '!important',
		color: secondaryC,
		border: '1px solid #fff'
	},
	orange: {
		backgroundColor: orangeB + '!important',
		color: orangeC,
		border: '1px solid #fff'
	},
	positive: {
		backgroundColor: positiveB + '!important',
		color: positiveC,
		border: '1px solid #fff'
	},
	negative: {
		backgroundColor: negativeB + '!important',
		color: negativeC,
		border: '1px solid #fff'
	},
	disabled: {
		backgroundColor: '#DCE6F3' + '!important',
		color: '#94A1B4',
		paddingLeft: 16,
		paddingRight: 16,
		paddingTop: 12,
		paddingBottom: 12,
		height: 41,
		borderRadius: 9
	}
}))

const AsterButton = ({ color, ...other }) => {
	const classes = useStyles()
	return (
		<Button
			className={
				other.disabled ? classes.disabled : `${classes.root} ${classes[color]}`
			}
			{...other}
		/>
	)
}

export default AsterButton

AsterButton.propTypes = {
	color: PropTypes.oneOf([
		'notActive',
		'default',
		'primary',
		'secondary',
		'positive',
		'negative'
	]),
	disabled: PropTypes.bool,
	onClick: PropTypes.func
}
